import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Link, useHistory } from "react-router-dom";
import {
  IoLogOutOutline,
  IoPersonCircleOutline,
  IoAlbumsOutline,
  IoSettingsOutline,
} from "react-icons/io5";

import { clientAuth, initials } from "../../../../shared/lib/clientSession";
import { ProfileSettingsModal } from "../../../LibraryModals/LibraryModals";

import styles from "./styles.module.scss";

// Header profile of a signed-in client (media company member):
// click the name / avatar → My account, Profile settings (name, job title,
// password), Collections, Log out
const ClientMenu = ({ client }) => {
  const [open, setOpen] = useState(false);
  const [settings, setSettings] = useState(false);
  const ref = useRef(null);
  const { push } = useHistory();

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => !ref.current?.contains(e.target) && setOpen(false);
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDoc);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  const { member, company } = client;
  const firstName = (member.name || member.email).split(" ")[0];

  return (
    <div className={styles.wrap} ref={ref}>
      <button
        type="button"
        className={styles.chip}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <span>{firstName}</span>
        <span className={styles.avatar}>{initials(member.name, member.email)}</span>
      </button>

      {open && (
        <div className={styles.menu} role="menu">
          <div className={styles.who}>
            <strong>{member.name || member.email}</strong>
            <span>{company?.name}</span>
            <span>{member.email}</span>
          </div>
          <Link to="/library/account" role="menuitem" className={styles.item} onClick={() => setOpen(false)}>
            <IoPersonCircleOutline />
            My account
          </Link>
          <button
            type="button"
            role="menuitem"
            className={styles.item}
            onClick={() => {
              setOpen(false);
              setSettings(true);
            }}
          >
            <IoSettingsOutline />
            Profile settings
          </button>
          <Link to="/library?view=collections" role="menuitem" className={styles.item} onClick={() => setOpen(false)}>
            <IoAlbumsOutline />
            Collections
          </Link>
          <button
            type="button"
            role="menuitem"
            className={`${styles.item} ${styles.logout}`}
            onClick={() => {
              setOpen(false);
              clientAuth.logout();
              push("/library");
            }}
          >
            <IoLogOutOutline />
            Log out
          </button>
        </div>
      )}

      {/* portal: the header is a containing block for fixed elements */}
      {settings &&
        createPortal(
          <ProfileSettingsModal
            member={member}
            company={company}
            onClose={() => setSettings(false)}
          />,
          document.body
        )}
    </div>
  );
};

export default ClientMenu;
